var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"badge-button z-50",style:({
    right: _vm.buttonPosition,
    width: _vm.badgeWidth,
    top: _vm.badgeTop,
    borderRadius: _vm.borderRadius,
  }),attrs:{"href":_vm.badgeLink,"target":"_blank"},on:{"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave}},[_c('img',{staticClass:"badge-image",style:({margin:_vm.marginImage}),attrs:{"src":_vm.badgeImage,"alt":"Badge"}}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showText),expression:"showText"}],staticClass:"badge-text py-4"},[_vm._v(_vm._s(_vm.badgeText)+" "),_c('span',[_vm._v("Saiba mais sobre >")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }